export const singleViewMovil = `
<svg width="39" height="28" viewBox="0 0 39 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.4" x="1.83523" y="1.58816" width="35.9656" height="24.8241" rx="3.87021" fill="#FF53FF" fill-opacity="0.2" stroke="#74767A" stroke-width="1.79828"/>
</svg>
`;